module.exports = require('./helpers/bundle-url').getBundleURL('6GpEv') + "logo-dark.eefe0b7f.svg";